module.exports = __webpack_public_path__ + "img/c6.0576714f.png";